import { render, staticRenderFns } from "./ArticleSlug.vue?vue&type=template&id=288ba9fa&"
import script from "./ArticleSlug.vue?vue&type=script&lang=ts&"
export * from "./ArticleSlug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports